// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Dropzone from 'react-dropzone'

// CSS
import './styles.scss'

// Components/Containers
import Spinner from '../../components/Spinner'
import UpDownIcon from '../../components/UpDownIcon'

// Other
import { formatDate } from '../../constants/others'

// Actions
import { downloadFile } from '../App/actions'
import { changeFiles, fetchFiles, uploadFiles } from './actions'

class Drive extends Component {
  // componentDidMount() {
  //   const { spCase: { id }, fetchFiles } = this.props
    
  //   fetchFiles(id)
  // }

  componentWillUnmount() {
    const { changeFiles } = this.props
    changeFiles([])
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    const { user, spCase: { id }, uploadFiles } = this.props

    uploadFiles(acceptedFiles, id, user)
  }

  onDownload = (e, spCaseId, fileRequest, fileId) => {
    const { downloadFile } = this.props

    downloadFile(spCaseId, fileRequest, fileId)

    e.stopPropagation()
  }

  openDialog = () => {
    this.refs.dropzone.open()
  }

  render() {
    const { download, user, files, spCase: { id } } = this.props

    return (
      <div className="drive">
        <div className="drive__header">
          <p className="drive__title">Pasta Compartilhada</p>
          <p className="drive__beta">BETA</p>
        </div>
        <Dropzone
          onDrop={this.onDrop}
          ref="dropzone"
          multiple={true}
          maxSize={1000000}
        >
          {({ getRootProps, getInputProps }) => {
            return (
              <section className="drive__dropzone" {...getRootProps()}>
                <input {...getInputProps()} />
                {_.isEmpty(files) &&
                  <div className="drive__content drive__content--empty" onClick={this.openDialog}>
                    <p className="drive__placeholder"><span>Arraste ou clique para anexar</span> e compartilhar documentos (até 1MB cada)</p>
                  </div>
                }
                {!_.isEmpty(files) &&
                  <div >
                    {files.map(file => (
                      <div
                        key={file.id}
                        className="drive__file"
                        onClick={(e) => this.onDownload(e, id, 'drive', file.id)}>
                        <div className="drive__text">
                          <p>{file.real_name}</p>
                          <p>{!file.data_upload ?
                            'Compartilhando...' :
                            `${formatDate(file.data_upload)}`}</p>
                        </div>
                        {file.data_upload &&
                          <UpDownIcon
                            err={download.err}
                            type="download"
                            progress={
                              download.spCaseId === id &&
                                download.fileRequest === 'drive' &&
                                download.fileId === file.id ?
                                download.progress >= download.total ?
                                  download.total / download.total :
                                  download.progress / download.total :
                                0}>
                            ZIP
                          </UpDownIcon>
                        }
                        {!file.data_upload &&
                          <Spinner />
                        }
                      </div>
                    ))}
                  </div>
                }
              </section>
            )
          }}
        </Dropzone>
        {!_.isEmpty(files) &&
          <p
            className="drive__placeholder drive__placeholder--small"
            onClick={e => {
              e.preventDefault()
              this.openDialog()
            }}>
            <span>Arraste ao campo acima ou clique aqui para compartilhar documentos (até 1MB cada)</span>
          </p>
        }
      </div>
    )
  }
}

Drive = connect(state => {
  return {
    download: state.app.download,
    user: state.auth.user,
    files: state.drive.files,
    spCase: state.spCasePage.spCase
  }
}, { downloadFile, changeFiles, fetchFiles, uploadFiles })(Drive)

export default Drive
